<template>
  <div
    class="drop-date-baremetric"
    @mouseenter="() => hovered = true"
    @mouseleave="() => hovered = false"
  >
    <!-- <transition
      mode="out-in"
      enter-active-class="anim-slide-bottom-small anim-fast"
      leave-active-class="anim-slide-top-small anim-reverse anim-fast"
    > -->
      <inner-bm
        class="daterange daterange--double one"
        key="on"
        :filter="filter"
        @change="value => $emit('change', value)"
        v-if="filtered || hoverWhenNotFiltered"
      ></inner-bm>
      <button
        class="button is-small no-filter-button"
        key="off"
        v-else
      >{{ currentDate }}</button>
    <!-- </transition> -->
  </div>
</template>

<script>
import InnerBm from './date-range-inner'
import Vue from 'vue'
import { DateTime } from 'luxon'
import store from '@/store'

export default {
  name: 'BDropDateBaremetric',
  components: {
    InnerBm,
  },
  props: {
    filter: { type: Object, default: () => null },
    filtered: { type: Boolean, default: () => false },
  },
  data() {
    return {
      hovered: false,
    }
  },
  computed: {
    timezone: () => store.state.user.me.timezone,
    currentDate() {
      return DateTime.local()
        .setZone(this.timezone)
        .toLocaleString(DateTime.DATE_SHORT)
    },
    hoverWhenNotFiltered() {
      return this.hovered && this.filtered === false
    },
  },
}
</script>

<style lang="scss" scoped>
.no-filter-button {
  height: 30px;
}
.daterange {
  min-width: 250px;
}
</style>
